<script lang="ts">
	import type { EditionsSectionCard } from '#lib/websites/artists/pages/ArtistDetailPage/utils/transformCatalogueEditions/index.js';
	import { ArtworkCard } from '$global/components/ArtworkCard';

	interface Props {
		dataCy: string;
		item: EditionsSectionCard;
	}

	let { dataCy, item }: Props = $props();

	// Standalone editions render in the same collection-card style as series, so
	// the two read as one grid of groups rather than two kinds of tile.
	let dataCyPrefix = $derived(
		item.__typename === 'Series' ? `${dataCy}-series` : `${dataCy}-edition`
	);
</script>

<ArtworkCard
	dataCy={dataCyPrefix}
	line1={item.name}
	line2={item.description}
	variants={{
		line2: 'markdown',
	}}
	class="relative rounded border"
	classes={{
		line2: 'line-clamp-3',
	}}
	href={item.href}
	image={{
		url: item.image.url,
		width: item.image.width || 0,
		height: item.image.height || 0,
	}}
	alt={item.name}
/>
